import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=efe9d588&"
import script from "./Loading.vue?vue&type=script&lang=js&"
export * from "./Loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/casperjureskog/CMM/creo-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efe9d588')) {
      api.createRecord('efe9d588', component.options)
    } else {
      api.reload('efe9d588', component.options)
    }
    module.hot.accept("./Loading.vue?vue&type=template&id=efe9d588&", function () {
      api.rerender('efe9d588', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Loading.vue"
export default component.exports